$(document).ready(function () {
    initQuicView();
});
function update_free_shipping_qw() {
    let $qw_free_shipping = $('.qw-product-content .js-free-shipping');
    $qw_free_shipping.find('[data-fd-text]').html(text_html);
    $qw_free_shipping.find('[data-fd-percent]').css({  width: percent + '%' });
    if(percent == 100){
        $qw_free_shipping.find('[data-fd-text]').addClass('free_delivery_start');
    }
    else{
        $qw_free_shipping.find('[data-fd-text]').removeClass('free_delivery_start');
    }
}
function initQuicView() {  
    let trimString = function (string, wordCount) {
        wordCount = wordCount != undefined ? wordCount : 10;
        var arr = string.split(/\s+/,wordCount);
        var newString = arr.join(" ");
        return newString;
    };

    let quickView = {
        qwProductImages: '.qw-product-images',
        variants: {},
        initMagnificPopup: function (modal, el) {
            let that = this;
            $.magnificPopup.open({
                items: {
                    src: modal.template,
                    type: 'inline'
                },
                callbacks: {
                    open: () => {
                    modal.lengthImages = $(that.qwProductImages).data('items');
            $('.qw-product-price').html(modal.price);

            if(modal.description.length > 200){
                $('.qw-product-desc').html(modal.description.slice(0,200) + "...");
            }
            else{
                $('.qw-product-desc').html(modal.description);
            }

            const productMiniature = el.closest('.product-miniature');
            const handleProduct = productMiniature.data('product-handle');
            $('.qw-product-content').attr('data-product-handle', handleProduct);
            modal.options.forEach(element => {
                if(element.values[0] != 'Default Title'){
                const copyElem = productMiniature.find(`.product-options.opt-${element.name.replace(' ','_')}`).closest('.product_opt_wrapp').html();
                const copyElemValue = productMiniature.find(`.product-options.opt-${element.name.replace(' ','_')}`).val();
                $('.qw-product-add').find(`.js-options-wrap-${element.name.replace(' ','_')}`).html(copyElem);
                if (copyElemValue.length) {
                    if(copyElemValue.indexOf('"') != -1){
                        $('.qw-product-add').find(`.js-options-wrap-${element.name.replace(' ','_')} select.product-options.opt-${element.name.replace(' ','_')} option[data-value='${copyElemValue.toLowerCase()}']`).attr('selected', true);
                    }
                    else{
                        $('.qw-product-add').find(`.js-options-wrap-${element.name.replace(' ','_')} select.product-options.opt-${element.name.replace(' ','_')} option[data-value="${copyElemValue.toLowerCase()}"]`).attr('selected', true);
                    }

                }
            }
        });

        }
        }
        });
        },
        initImagesSlider: function(box) {
            box.addClass('owl-carousel owl-theme');
            box.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                URLhashListener:true,
                startPosition: 'URLHash',
                navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>']
            });
        }
    };
    $(document).on('click','.quick-view-link', function (e) {
        e.preventDefault();
        let el = $(this);
        let handle = el.data('handle');
        let images = el.closest('.product-miniature').data('json-product').qw_images;

        $.ajax({
            url: '/products/'+handle+'.js',
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                let source = $('#quickView').html();
                let template = Handlebars.compile(source);
                let imagesLength = null;
                let dataNew = {...data, images};
                let modal = {
                    template: template(dataNew),
                    lengthImages: null,
                    product: dataNew,
                    options: dataNew.options,
                    price: el.closest('.product-miniature').find('.product-price-and-shipping').html(),
                    description: trimString(dataNew.description, 70) + '...'
                };
                quickView.initMagnificPopup(modal, el);
                updateVariantsQuickView(el);

                $('.qw-modal').find('.product-options[data-section-name="color"] .js-option').each(function() {
                    let color = $(this).data('value');
                    $(this).css('backgroundColor', color);
                });
                if ( modal.lengthImages > 1 ) {
                    quickView.initImagesSlider($(quickView.qwProductImages));
                }

                if($('#CartDrawer')) {
                    ajaxCart.init({
                        formSelector: '#AddToCartForm',
                        cartContainer: '#CartContainer',
                        addToCartSelector: '#AddToCart',
                        cartCountSelector: '.cart-count',
                        cartCostSelector: '#CartCost',
                        moneyFormat: null
                    });
                    if($('.buy_product_on_footer')) {
                        ajaxCart.init({
                            formSelector: '#AddToCartFormFooter',
                            cartContainer: '#CartContainer',
                            addToCartSelector: '#AddToCart',
                            cartCountSelector: '.cart-count',
                            cartCostSelector: '#CartCost',
                            moneyFormat: null
                        });
                    }
                }
                
              	setTimeout(function(){
                    bundle_custom_quickview();
                },100);
              
              	update_free_shipping_qw();

            }
        });
    });
}
function loadScript(url, callback){
  var script = document.createElement("script")
  script.type = "text/javascript";
  if (script.readyState){ //IE
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" ||
          script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
  } else { //Others
    script.onload = function(){
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

var myAppJavaScript = function($){
  $(document).ready(function(){
    var form;
    //if($('.Zb_wrapper').length){
      const bundle_id=$('.quickview-form input[name^=id]:checked, .quickview-form select[name^=id], .quickview-form input[name=id], .quickview-form hidden[name^=id]', form).val();
      //alert(bundle_id);
      $.ajax({
        method:'GET',
        dataType: "JSON",
        url:'/apps/zebundler/get_bundle_content?variant='+bundle_id,
        success: function(data){
          if(data.component.length >0){
            //$('.Zb_wrapper').append($('<div class="zb_title">PACK CONTENTS</div>'));
            var table = $('<table class="zb_table"><tr class="zb_header"><th></th><th>Product</th><th>Quantity</th></tr></table>');
            var bundle_content = "";
            var bundle_count=0;
            for (var i = data.component.length - 1; i >= 0; i--) {
              bundle_count++;
              const component=data.component[i];
              var comp_view=$(`<tr class="zb_raw"><td><img class="zb_img" src="${component.img.src}" /></td>
<td>${component.title}</td><td>${component.quantity}</td></tr>`);
              table.append(comp_view);

              if(bundle_count != 1){
                bundle_content +=', ';
              }                
              bundle_content +=component.title+' X '+component.quantity;

            }
            //$('.Zb_wrapper').append(table);
            //console.log(bundle_content);
            
            var bundle_item_quick = document.getElementsByClassName("bundle_item_quick");
            //console.log(bundle_item_quick[0]);
            
			bundle_item_quick[0].value = bundle_content;
            
            //$('.bundle_item').val(bundle_content);
          }
        }
      })
    //}
  });
};

function bundle_custom_quickview($){
	//alert('aa');
	//var bundle_content = 'new products x 1';  	
  	
  
  	if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
        jQuery191 = jQuery.noConflict(true);
        myAppJavaScript(jQuery191);
      });
    } else {
      myAppJavaScript(jQuery);
    }
  
}